import { render, staticRenderFns } from "./ReferralTransactions.vue?vue&type=template&id=6afeedee&"
import script from "./ReferralTransactions.vue?vue&type=script&lang=ts&"
export * from "./ReferralTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports